const selectAll = 'Select all that apply';
const yes = 'Yes';
const no = 'No';

const goalHowMuchDepositNow = 'How much have you saved to date?';
const goalTotalAmount = 'How much do you need to achieve this goal?';
const loanAccess = 'How would you like to access these funds?';
const accessType = 'Access:';
const never = 'Never';
const rarely = 'Rarely';
const frequently = 'Frequently';
const borrowOrSave = 'Would you like to borrow or save for this goal?';

const welcome = 'Welcome to WSFS';
const exit = 'Wrapping up';
const financialFuture = 'Your future financial well being is important.';
const goals = 'Help us understand your goals.';
const financialSituation = 'Help us understand your current financial situation to help assist you.';

const openAccountActionType = 1; // deposit products
const openLineOfCredit = 2; // HELOC
const openAutoLoan = 3; //  auto loan
const cashBackCreditCard = 4; // cash back cc
const lowInterestCreditCard = 5; // low interest cc
const homeEquityLoan = 6; // HELOAN
const upstartActionType = 7;
const contactUsActionType = 8;
const enrollOnlineActionType = 9;
const getTheAppActionType = 10;
const lendingSpecialist = 11;


const firstName = 'First Name';
const lastName = 'Last Name';
const email = 'Email';
const phone = 'Phone';

export default {

  'guide.name': 'WSFS Guide',
  'guide.context': 'WSFS Consumer Online',

  'products.features.title': 'Why is this product for me?',
  'products.disclosures.title': 'Disclosures',

  'nav.prev': 'Back',
  'nav.next': 'Next',

  'landing.title': 'FAST. EASY. PERSONALIZED.',
  'landing.message': "Let's find the right products for your financial needs",
  'landing.getStarted': 'Get Started',
  'landing.footer': 'WSFS Bank, FSB | Member FDIC | NMLS #417673',

  'redirectMessage.path': 'Starting new path...',
  'sidebar.isCustomer.message': welcome,
  'sidebar.reasonForVisit.message': welcome,
  'sidebar.customerReferral.message': welcome,
  'sidebar.banking.message': "Let's explore the banking benefits you need to achieve your goals.",
  'sidebar.currentServicesAndFeatures.message': 'What is your banking style?',
  'sidebar.interestedServicesAndFeatures.message': 'There are so many convenient ways to interact with your accounts today.',
  'sidebar.currentMoneyManagementHabits.message': 'Please share how you like to access your funds.',
  'sidebar.balances.message': financialSituation,
  'sidebar.creditCardOptions.message': financialSituation,
  'sidebar.creditCardReasons.message': financialSituation,
  'sidebar.savingsGoals.message': goals,
  'sidebar.homeOwner.message': goals,
  'sidebar.homeType.message': goals,
  'sidebar.homeEquity.message': goals,
  'sidebar.stayingConnected.message': financialFuture,
  'sidebar.ageAndIncome.message': financialFuture,
  'sidebar.postalCode.message': financialFuture,
  'sidebar.openAccountPreferences.message': financialFuture,


  'footer.copyright': 'WSFS Bank',
  'footer.housing': 'Equal Housing Opportunity',
  'footer.privacy': 'Important notice regarding use of cookies: By continuing to use this site, you agree to our use of cookies as described in our Privacy Policy.',

  'summary.answers': 'See my Answers',
  'summary.header': 'Your Personalized Banking Solutions',
  'summary.footer': 'WSFS Bank, FSB | Member FDIC | NMLS #417673',
  'summary.uuidMessage': 'Your recommendations have been updated',
  'summary.mobile': 'Text',
  'summary.email': 'Email',
  'summary.print': 'Print',

  'cart.add': 'Add to Cart',
  'cart.remove': 'Added',
  'cart.header': 'Thank you!',
  'cart.empty': 'Your Cart is Empty',
  'cart.empty.message': 'Fill your cart with your personalized WSFS Bank Solutions',
  'cart.empty.button': 'Return To Recommendations',
  'cart.header.apply': 'Apply Online',
  'cart.header.contact': 'Contact Us',
  'cart.header.enroll': 'Enroll Online',
  'cart.header.app': 'App Store',
  'cart.product.apply': 'Apply Online',
  'cart.product.terafina': 'Apply Online',
  'cart.product.upstart': 'Apply Online',
  'cart.product.homeLoan': 'Email Sent',
  'cart.product.homeLoan.emailAdvice': 'A lending specialist will be reaching out to you within 2 business days, to answer your questions and take your application. If you would like immediate assistance, please call our Direct Bank Team at 1.877.792.3401.',
  'cart.product.lendingSpecialist': 'Email Sent',
  'cart.product.lendingSpecialist.emailAdvice': 'A lending specialist will be reaching out to you within 2 business days. If you would like immediate assistance, please call 1.888.973.7226.',
  'cart.product.contact': 'Enroll After Opening',
  'cart.product.enroll': 'Enroll After Opening',
  'cart.product.app': 'Enroll After Opening',
  'cart.product.sendEmail': 'Send Email',

  'formInput.error.required': 'required',
  'formInput.error.validate': 'invalid format',
  'formInput.error.pattern': 'invalid format',

  'shareViaEmailComplete.modal.title': 'Success!',
  'shareViaEmailComplete.message': 'A copy of your recommendations has been sent to your email!',
  'shareViaEmail.formBody': 'Enter your email below to receive your personalized banking solutions.',
  'shareViaSms.formBody': 'Enter your phone number to receive your personalized banking solutions.',

  'error.title': 'Error',
  'error.question.required': 'This question requires an answer',
  'error.question.zipCode': 'Please enter a valid zip code',
  'error.question.postalCode': 'Please enter a valid zip code',

  /**
   * ============================
   * CONSUMER ONLINE QUESTIONS
   * ============================
   */

  'isCustomer': 'What best describes your current relationship with WSFS?',
  'isCustomer.true': 'I have personal accounts with WSFS ',
  'isCustomer.false': 'I am new to WSFS ',

  'reasonForVisit': 'How may we assist you today?',
  'reasonForVisit.subtext': selectAll,
  'reasonForVisit.checking': 'Checking Solutions',
  'reasonForVisit.checking.icon': '/classpath/assets/images/icons/svg/check.svg',
  'reasonForVisit.savings': 'Savings Solutions',
  'reasonForVisit.savings.icon': '/classpath/assets/images/icons/svg/piggybank.svg',
  'reasonForVisit.borrow': 'Borrowing Solutions',
  'reasonForVisit.borrow.icon': '/classpath/assets/images/icons/svg/dollar-fan.svg',

  'exploreGoals': 'Would you be interested in exploring goals?',
  'exploreGoals.true': 'Yes',
  'exploreGoals.false': 'No',

  balancesGroup: "Let's discuss the balances you plan to keep at WSFS",
  'balancesGroup.tooltip': "All WSFS Bank accounts require at least $100 to open.",
  averageCheckingAccountBalance: 'Average checking balance',
  savingsAndMmAccountBalance: 'Savings and/or Money Market',
  cdAccountBalance: 'CDs',

  'creditCardReasons': 'Do you like to use credit cards for any of the following reasons?',
  'creditCardReasons.convenience': 'Convenience of everyday purchases',
  'creditCardReasons.easeOfPurchase': 'Ease of making large purchases',
  'creditCardReasons.safety': 'Safety while you travel',
  'creditCardReasons.none': "I don't use credit cards",

  // #7
  'creditCardOptions': 'What is the most important feature of a credit card for you?',
  'creditCardOptions.lowerInterest': 'I like a lower interest rate',
  'creditCardOptions.cashBack': 'I like to earn cash back',

  // #8
  'openAccountPreferences': 'Would you be interested in opening a checking or savings account with WSFS?',
  'openAccountPreferences.true': 'Yes',
  'openAccountPreferences.false': 'No',


  'savingsGoals': 'Goals',
  savingsGoalsGroup: 'Tell us about your goals?',
  'savingsGoalsGroup.subtext': selectAll,

  'savingsGoals.cardBuilder.addCard': 'Select',
  'savingsGoals.cardBuilder.removeCard': '<icon>fa fa-times-circle</icon>',
  'savingsGoals.cardBuilder.editCard': '<icon>fa fa-pencil</icon>',
  'savingsGoals.cardBuilder.saveCard': 'Save <icon>fa-caret-right"</icon>',
  'savingsGoals.cardBuilder.modal.title': 'Short Term Savings Goals',

  'savingsGoals.savingsGoalsMajorPurchase': 'Major Purchase',
  'savingsGoals.savingsGoalsMajorPurchase.icon': '/classpath/assets/images/icons/svg/dollar-fan.svg',
  'savingsGoals.savingsGoalsMajorPurchase.title': 'Major Purchase',
  'savingsGoalsMajorPurchase.cardBuilder.title': 'Major Purchase',
  savingsGoalsMajorPurchaseDepositNow: goalHowMuchDepositNow,
  savingsGoalsMajorPurchaseTotalAmount: goalTotalAmount,
  savingsGoalsMajorPurchaseAccess: loanAccess,
  'savingsGoalsMajorPurchaseAccess.never': never,
  'savingsGoalsMajorPurchaseAccess.rarely': rarely,
  'savingsGoalsMajorPurchaseAccess.frequently': frequently,
  'savingsGoalsMajorPurchaseAccess.cardBuilder.answerLabel': accessType,
  'details.savingsGoalsMajorPurchaseAccess': `Goals: Major Purchase | ${loanAccess}`,
  savingsGoalsMajorPurchaseBorrowOrSave: borrowOrSave,
  'savingsGoalsMajorPurchaseBorrowOrSave.borrow': 'Borrow',
  'savingsGoalsMajorPurchaseBorrowOrSave.save': 'Save',

  'savingsGoals.savingsGoalsHomeImprovement': 'Home Improvement/Repairs',
  'savingsGoals.savingsGoalsHomeImprovement.icon': '/classpath/assets/images/icons/svg/house.svg',
  'savingsGoals.savingsGoalsHomeImprovement.title': 'Home Improvement/Repairs',
  'savingsGoalsHomeImprovement.cardBuilder.title': 'Home Improvement/Repairs',
  savingsGoalsHomeImprovementDepositNow: goalHowMuchDepositNow,
  savingsGoalsHomeImprovementTotalAmount: goalTotalAmount,
  savingsGoalsHomeImprovementAccess: loanAccess,
  'savingsGoalsHomeImprovementAccess.never': never,
  'savingsGoalsHomeImprovementAccess.rarely': rarely,
  'savingsGoalsHomeImprovementAccess.frequently': frequently,
  'savingsGoalsHomeImprovementAccess.cardBuilder.answerLabel': accessType,
  'details.savingsGoalsHomeImprovementAccess': `Goals: Home Improvement | ${loanAccess}`,
  savingsGoalsHomeImprovementBorrowOrSave: borrowOrSave,
  'savingsGoalsHomeImprovementBorrowOrSave.borrow': 'Borrow',
  'savingsGoalsHomeImprovementBorrowOrSave.save': 'Save',

  'savingsGoals.savingsGoalsVehicle': 'Purchase a vehicle',
  'savingsGoals.savingsGoalsVehicle.icon': '/classpath/assets/images/icons/svg/dollars.svg',
  'savingsGoals.savingsGoalsVehicle.title': 'Purchase a Vehicle',
  'savingsGoalsVehicle.cardBuilder.title': 'Purchase a Vehicle',
  savingsGoalsVehicleDepositNow: goalHowMuchDepositNow,
  savingsGoalsVehicleTotalAmount: goalTotalAmount,
  savingsGoalsVehicleAccess: loanAccess,
  'savingsGoalsVehicleAccess.never': never,
  'savingsGoalsVehicleAccess.rarely': rarely,
  'savingsGoalsVehicleAccess.frequently': frequently,
  'savingsGoalsVehicleAccess.cardBuilder.answerLabel': accessType,
  'details.savingsGoalsVehicleAccess': `Goals: Purchase a vehicle | ${loanAccess}`,
  savingsGoalsVehicleBorrowOrSave: borrowOrSave,
  'savingsGoalsVehicleBorrowOrSave.borrow': 'Borrow',
  'savingsGoalsVehicleBorrowOrSave.save': 'Save',

  'savingsGoals.savingsGoalsVacation': 'Vacation/Planning for a wedding',
  'savingsGoals.savingsGoalsVacation.icon': '/classpath/assets/images/icons/svg/piggybank.svg',
  'savingsGoals.savingsGoalsVacation.title': 'Vacation/Planning for a Wedding',
  'savingsGoalsVacation.cardBuilder.title': 'Vacation/Planning for a Wedding',
  savingsGoalsVacationDepositNow: goalHowMuchDepositNow,
  savingsGoalsVacationTotalAmount: goalTotalAmount,
  savingsGoalsVacationAccess: loanAccess,
  'savingsGoalsVacationAccess.never': never,
  'savingsGoalsVacationAccess.rarely': rarely,
  'savingsGoalsVacationAccess.frequently': frequently,
  'savingsGoalsVacationAccess.cardBuilder.answerLabel': accessType,
  'details.savingsGoalsVacationAccess': `Goals: Vacation/Planning for a wedding | ${loanAccess}`,
  savingsGoalsVacationBorrowOrSave: borrowOrSave,
  'savingsGoalsVacationBorrowOrSave.borrow': 'Borrow',
  'savingsGoalsVacationBorrowOrSave.save': 'Save',

  'savingsGoals.savingsGoalsDebtConsolidation': 'Debt Consolidation',
  'savingsGoals.savingsGoalsDebtConsolidation.icon': '/classpath/assets/images/icons/svg/cash-hand.svg',
  'savingsGoals.savingsGoalsDebtConsolidation.title': 'Debt Consolidation',
  'savingsGoalsDebtConsolidation.cardBuilder.title': 'Debt Consolidation',
  savingsGoalsDebtConsolidationDepositNow: goalHowMuchDepositNow,
  savingsGoalsDebtConsolidationTotalAmount: goalTotalAmount,
  savingsGoalsDebtConsolidationAccess: loanAccess,
  'savingsGoalsDebtConsolidationAccess.never': never,
  'savingsGoalsDebtConsolidationAccess.rarely': rarely,
  'savingsGoalsDebtConsolidationAccess.frequently': frequently,
  'savingsGoalsDebtConsolidationAccess.cardBuilder.answerLabel': accessType,
  'details.savingsGoalsDebtConsolidationAccess': `Goals: Debt Consolidation | ${loanAccess}`,
  savingsGoalsDebtConsolidationBorrowOrSave: borrowOrSave,
  'savingsGoalsDebtConsolidationBorrowOrSave.borrow': 'Borrow',
  'savingsGoalsDebtConsolidationBorrowOrSave.save': 'Save',

  'savingsGoals.savingsGoalsRainyDay': 'Rainy Day fund',
  'savingsGoals.savingsGoalsRainyDay.icon': '/classpath/assets/images/icons/svg/dollar-stack.svg',
  'savingsGoals.savingsGoalsRainyDay.title': 'Rainy Day Fund',
  'savingsGoalsRainyDay.cardBuilder.title': 'Rainy Day Fund',
  savingsGoalsRainyDayDepositNow: goalHowMuchDepositNow,
  savingsGoalsRainyDayTotalAmount: goalTotalAmount,
  savingsGoalsRainyDayAccess: loanAccess,
  'savingsGoalsRainyDayAccess.never': never,
  'savingsGoalsRainyDayAccess.rarely': rarely,
  'savingsGoalsRainyDayAccess.frequently': frequently,
  'savingsGoalsRainyDayAccess.cardBuilder.answerLabel': accessType,
  'details.savingsGoalsRainyDayAccess': `Goals: Rainy Day fund | ${loanAccess}`,
  savingsGoalsRainyDayBorrowOrSave: borrowOrSave,
  'savingsGoalsRainyDayBorrowOrSave.borrow': 'Borrow',
  'savingsGoalsRainyDayBorrowOrSave.save': 'Save',

  'savingsGoals.savingsGoalsNoGoals': 'No Current Goals',
  'savingsGoals.savingsGoalsNoGoals.icon': '/classpath/assets/images/icons/svg/wallet.svg',
  'savingsGoals.savingsGoalsNoGoals.title': 'No Current Goals',

  goalsAccess: loanAccess,
  'goalsAccess.never': never,
  'goalsAccess.rarely': rarely,
  'goalsAccess.frequently': frequently,

  goalsTotalAmount: 'Total Savings Goal Amount',
  goalsTotalSavedAmount: 'Total Saved To Date',

  homeOwner: 'Are you a homeowner?',
  'homeOwner.true': 'Yes',
  'homeOwner.false': 'No',

  homeType: 'What type of home do you have?',
  'homeType.singleFamily': 'Single Family',
  'homeType.townhome': 'Townhome',
  'homeType.condo': 'Condominium',
  'homeType.manufacturedHome': 'Manufactured Home',

  homeValue: 'What is the value of your home?',

  mortgageLoanBalance: 'What is your mortgage balance?',
  'mortgageLoanBalance.tooltip': 'This includes mortgage balances, equity loans, and any liens.',

  homeEquity: 'Do you want to use the equity in your home for purpose of your goal?',
  'homeEquity.true': 'Yes',
  'homeEquity.false': 'No',

  homeEquityTiming: 'How would you like to access your funds?',
  'homeEquityTiming.upFront': 'Up front',
  'homeEquityTiming.overTime': 'Over time',

  stayingConnected: 'How would you like to keep in touch with us?',
  'stayingConnected.subtext': selectAll,
  'stayingConnected.mobilePhone': 'Mobile Phone',
  'stayingConnected.email': 'Email',

  'postalCodeGroup': 'Where do you live?',
  'postalCode': 'Zip Code',
  'postalCode.input.placeholder': 'Enter your zip code',


  /**
   * ============================
   * DEPRECATED QUESTIONS
   * ============================
   */

  'customerReferral': 'How did you hear about WSFS?',
  'customerReferral.subtext': selectAll,
  'customerReferral.convenient': 'Convenient locations',
  'customerReferral.reputation': 'Great reputation',
  'customerReferral.community': 'I value a community bank',
  'customerReferral.advertisement': 'I saw an advertisement/received something in the mail',
  'customerReferral.referred': 'I was referred',

  otherConsumerBank: 'Other than WSFS, where do you do your banking?',
  'otherConsumerBank.noOtherBank': 'No other bank',
  'otherConsumerBank.artisans': "Artisan's",
  'otherConsumerBank.bBAndT': 'BB&T',
  'otherConsumerBank.bankOfAmerica': 'Bank of America',
  'otherConsumerBank.capitalOne': 'Capital One',
  'otherConsumerBank.citizens': 'Citizens',
  'otherConsumerBank.countyBank': 'County Bank',
  'otherConsumerBank.creditUnion': 'Credit Union',
  'otherConsumerBank.fulton': 'Fulton',
  'otherConsumerBank.mAndT': 'M&T',
  'otherConsumerBank.pnc': 'PNC',
  'otherConsumerBank.shoreUnited': 'Shore United',
  'otherConsumerBank.td': 'TD',
  'otherConsumerBank.wellsFargo': 'Wells Fargo',
  'otherConsumerBank.other': 'Other',

  currentServicesAndFeatures: 'Please select which services and features are important to you?',
  'currentServicesAndFeatures.subtext': selectAll,
  'currentServicesAndFeatures.debitCard': 'Debit Card',
  'currentServicesAndFeatures.creditCard': 'Credit Card',
  'currentServicesAndFeatures.onlineBillPay': 'Online Bill Pay',
  'currentServicesAndFeatures.recurringTransfers': 'Recurring Transfers',
  'currentServicesAndFeatures.overdraftProtection': 'Overdraft Protection',

  interestedServicesAndFeatures: 'Which of the following are important to you?',
  'interestedServicesAndFeatures.subtext': selectAll,
  'interestedServicesAndFeatures.mobileBanking': 'Mobile Banking',
  'interestedServicesAndFeatures.onlineBanking': 'Online Banking',
  'interestedServicesAndFeatures.eStatements': 'E-statements',
  'interestedServicesAndFeatures.mobilePayments': 'Mobile Payments',
  'interestedServicesAndFeatures.mobilePayments.tooltip': 'ApplePay, Zelle, Paypal, Venmo, etc.',

  currentMoneyManagementHabits: 'How do you like to make deposits and complete withdraws?',
  'currentMoneyManagementHabits.subtext': selectAll,
  'currentMoneyManagementHabits.atm': 'ATM',
  'currentMoneyManagementHabits.inPerson': 'In person at the branch',
  'currentMoneyManagementHabits.directDeposit': 'Direct deposit',
  'currentMoneyManagementHabits.mobileDeposit': 'Mobile deposit',

/**
 * ============================
 * REVIEW QUESTIONS
 * ============================
 */


  savingsReview: 'We would love to help you with all your banking needs. Would you like to review your savings goals today?',
  'savingsReview.true': yes,
  'savingsReview.false': no,

  checkingReview: 'We would love to help you with all your banking needs. Would you like to review your checking needs today?',
  'checkingReview.true': yes,
  'checkingReview.false': no,

/**
 * ============================
 * DEMOGRAPHICS QUESTIONS
 * ============================
 */

  ageGroup: 'What is your age?',
  age: 'Age',

  householdIncomeGroup: 'What is your household income?',
  householdIncome: 'Income',

  /**
   * ===========================
   * SUMMARY PAGE
   * ===========================
   */
  'contactMeForm.formInput.firstName': firstName,
  'contactMeForm.formInput.lastName': lastName,
  'contactMeForm.formInput.email': email,
  'contactMeForm.formInput.phone': phone,

  'contactMeForm.openAccountHeader': "Continue Your Journey!",
  'contactMeForm.openAccount.1': "Thank you for exploring WSFS Bank Solutions. Please provide your name, email, and phone number to begin your application.",
  'contactMeForm.openAccount.2': "For your convenience, you will also receive a copy of your personalized WSFS Bank recommendations via email.",
  'contactMeForm.contactUsHeader': 'Share Your Results With Us',
  'contactMeForm.contactUs': "Before you contact us, please share your results with us by submitting the form below. We'll link your name, email, and phone number to your answers so we can better help you when you get in touch. We'll also email you a copy of your recommendation. Submit your info to get our contact information.",
  'contactMeForm.enrollOnlineHeader': 'Before You Continue',
  'contactMeForm.enrollOnline': "Before you continue, please share your results with us by submitting the form below. We'll link your name, email, and phone number to your answers so we can better help you when you get in touch. We'll also email you a copy of your recommendation. Submit your info to get our contact information.",
  'contactMeForm.getTheAppHeader': 'Before You Continue',
  'contactMeForm.getTheApp': "Before you continue, please share your results with us by submitting the form below. We'll link your name, email, and phone number to your answers so we can better help you when you get in touch. We'll also email you a copy of your recommendation. Submit your info to get our contact information.",

  'formInput.firstName.placeholder': firstName,
  'formInput.lastName.placeholder': lastName,
  'formInput.email.placeholder': email,
  'formInput.phone.placeholder': phone,
  'formInput.error.required': 'required',
  'formInput.error.validate': 'required',
  'error.question.zipCode': 'Please enter a valid zip code',
  'error.question.postalCode': 'Please enter a valid zip code',

  'openAccountSuccessHeader': 'Apply Now',
  'openAccountSuccessButton': 'Apply Now',

  'contactUsSuccessHeader': 'Contact Us',
  'contactUsSuccessButton': 'Close',

  'enrollOnlineSuccessHeader': 'Enroll Online',
  'enrollOnlineSuccessButton': 'Enroll Online',

  'getTheAppSuccessHeader': 'Get The App',
  'getTheAppSuccessButton': 'Get The App',

  'uuidMessage': 'Below are the WSFS Bank personalized recommendations you have selected.',

  /**
   * ===========================
   * PRODUCTS
   * ===========================
   */

  'product.actionType.openAccount': openAccountActionType,
  'product.actionType.upstart': upstartActionType,
  'product.actionType.contactUs': contactUsActionType,
  'product.actionType.enrollOnline': enrollOnlineActionType,
  'product.actionType.getTheApp': getTheAppActionType,

  'product.actionButton.openAccount': 'Apply Now',
  'product.actionButton.terafina': 'Apply Now',
  'product.actionButton.upstart': 'Apply Now',
  'product.actionButton.contactUs': 'Contact Us',
  'product.actionButton.enrollOnline': 'Enroll Online',
  'product.actionButton.getTheApp': 'Get the App',
  'product.actionButton.sendEmail': 'Send Email',

  'product.actionUrl.enrollOnline': 'https://cibng.ibanking-services.com/cib/themes/cib_enroll/enroll/enroll.jsp?FIORG=108&FIFID=031100102',
  'product.actionUrl.getTheApp': 'https://www.wsfsbank.com/banking/online-mobile-banking',
  'product.actionUrl.oaoTesting': 'https://newaccount.wsfsbank.com',
  'product.actionUrl.oaoProduction': 'https://newaccount.wsfsbank.com',
  'product.actionUrl.upstart': 'https://wsfsbank.upstart.com/funding_form',
  'product.actionUrl.sendEmail': 'mailto:directbankdl@wsfsbank.com',

  '14100.name': 'Relationship Checking',
  '14100.url': 'https://www.wsfsbank.com/personal/banking/checking/relationship-checking/?utm_source=enlighten&utm_content=learnmore',
  '14100.description.abbreviated': 'For Customers who typically maintain higher balances and want to get more from their checking account, such as bonus rates and discounts on select services.',
  '14100.features.count': 7,
  '14100.features.1': 'Tiered interest rates allow Customers to earn higher interest rates with higher balances.',
  '14100.features.2': 'Offers benefits for relationship Customers who have additional deposit and loan accounts.*',
  '14100.features.3': 'Earn bonus interest rates on related qualifying accounts.**',
  '14100.features.4': 'No charge for using non-WSFS ATMs.***',
  '14100.features.5': 'Rate discount on consumer loans with automatic payment.****',
  '14100.features.6': 'Convenient online and mobile banking access.',
  '14100.features.7': 'Convenient account access with a WSFS Visa<sup>®</sup> Debit Card with the Visa<sup>®</sup> Zero Liability Guarantee.*****',
  '14100.additionalInfo.count': 5,
  '14100.additionalInfo.1': 'Monthly Average Balance: >=$5000 -or-',
  '14100.additionalInfo.2': 'Combined Deposit Balance: >=$25000 (Checking, Savings, MM, and Loans. Not CC or Mortgage)',
  '14100.additionalInfo.3': 'Monthly Maintenance Cost: $15',
  '14100.additionalInfo.4': 'Electronic or Paper statement at no cost',
  '14100.additionalInfo.5': '<a class="additionalInfoLink" href="http://wsfsweb/Portals/5/Product%20Information/Personal%20%20Solutions-%20Checking%208-2019.asd.pdf">View Checking Solution Grid</a>',
  '14100.disclosures.count': 5,
  '14100.disclosures.1': '*Monthly average combined balances include checking, savings and money market accounts and all WSFS Consumer Loan and Lines outstanding excluding WSFS Mortgages and Credit Cards.',
  '14100.disclosures.2': '**Bonus interest rates on WSFS Relationship Checking require 15 debit card purchases within a statement cycle and require minimum average balances. The debit card purchase requirement is waived for customers over 60 years old.',
  '14100.disclosures.3': '***No charge on ATM transactions at non-WSFS ATMs; surcharges by the ATM owner may apply.',
  '14100.disclosures.4': '****Rate discount does not apply to the following products: lines of credit, CD-secured loans, lot loans or single payment loans.',
  '14100.disclosures.5': "*****Visa<sup>®</sup>'s Zero Liability policy covers U.S.-issued cards only and does not apply to ATM transactions, PIN transactions not processed by Visa<sup>®</sup>, or certain commercial card transactions. Cardholder must notify issuer promptly of any unauthorized use. It also excludes a transaction made by a person authorized to transact business on the account and/or a transaction made by a cardholder that exceeds the authority given by the account owner.",
  '14100.action.productCode': 'RCC',
  '14100.action.type': openAccountActionType,

  '14161.name': 'Everyday Banking',
  '14161.url': 'https://www.wsfsbank.com/personal/banking/checking/everyday-banking/?utm_source=enlighten&utm_content=learnmore',
  '14161.description.abbreviated': 'For Customers who want a basic checking account with easy access to their money.',
  '14161.features.count': 5,
  '14161.features.1': 'No monthly maintenance fees when you set up direct deposit or maintain a $500 monthly average balance<sup>*</sup>',
  '14161.features.2': 'Rate discount on consumer loans.**',
  '14161.features.3': 'Convenient online and mobile banking access.',
  '14161.features.4': 'Convenient account access with a WSFS Visa<sup>®</sup> Debit Card with the Visa<sup>®</sup> Zero Liability Guarantee.***',
  '14161.features.5': 'Online account statements, snapshot deposit and overdraft protection available for easy access.',
  '14161.additionalInfo.count': 3,
  '14161.additionalInfo.1': 'Monthly Average Balance: $500 to avoid $6 cost.',
  '14161.additionalInfo.2': 'Electronic or Paper Statement available at no cost.',
  '14161.additionalInfo.3': '<a class="additionalInfoLink" href="http://wsfsweb/Portals/5/Product%20Information/Personal%20%20Solutions-%20Checking%208-2019.asd.pdf">View Checking Solution Grid</a>',
  '14161.disclosures.count': 3,
  '14161.disclosures.1': '*If you do not enroll in online statements within 2 months of account opening, a $3 paper statement fee will apply. Simply establish direct deposit within 3 months of account opening date or maintain a $500 monthly average balance<sup>*</sup>',
  '14161.disclosures.2': '**Rate discount does not apply to the following products: lines of credit, CD-secured loans, lot loans or single payment loans.',
  '14161.disclosures.3': "***Visa<sup>®</sup>'s Zero Liability policy covers U.S.-issued cards only and does not apply to ATM transactions, PIN transactions not processed by Visa<sup>®</sup>, or certain commercial card transactions.  Cardholder must notify issuer promptly of any unauthorized use. It also excludes a transaction made by a person authorized to transact business on the account and/or a transaction made by a cardholder that exceeds the authority given by the account owner.",
  '14161.action.productCode': 'EBC',
  '14161.action.type': openAccountActionType,

  '14160.name': 'Campus Banking',
  '14160.url': 'https://www.wsfsbank.com/banking/checking-savings/personal-checking/campus-banking/?utm_source=enlighten&utm_content=learnmore',
  '14160.description.abbreviated': 'For students and young adults who want easy access to their funds with no hidden costs.*',
  '14160.features.count': 4,
  '14160.features.1': 'No paper statement fee when signed up for online statements.**',
  '14160.features.2': '$10 per month refunded of non-WSFS ATM fees.',
  '14160.features.3': 'No minimum balance requirement to avoid monthly maintenance fee.',
  '14160.features.4': 'Convenient account access with a WSFS Visa<sup>®</sup> Debit Card with the Visa<sup>®</sup> Zero Liability Guarantee.***',
  '14160.additionalInfo.count': 2,
  '14160.additionalInfo.1': 'No minimum balance requirements and competitive interest checking rate. Enroll in online statements to avoid $3 monthly paper statement fee.',
  '14160.additionalInfo.2': '<a class="additionalInfoLink" href="http://wsfsweb/Portals/5/Product%20Information/Personal%20%20Solutions-%20Checking%208-2019.asd.pdf">View Checking Solution Grid</a>',
  '14160.disclosures.count': 3,
  '14160.disclosures.1': '*Account is converted to Alumni Banking account when Customer turns 25 with the same features, benefits and requirements as the WSFS Campus Banking account.',
  '14160.disclosures.2': '**If you do not enroll in online statements within 2 months of account opening, a $3 fee will apply.',
  '14160.disclosures.3': "***Visa<sup>®</sup>'s Zero Liability policy covers U.S.-issued cards only and does not apply to ATM transactions, PIN transactions not processed by Visa<sup>®</sup>, or certain commercial card transactions.  Cardholder must notify issuer promptly of any unauthorized use. It also excludes a transaction made by a person authorized to transact business on the account and/or a transaction made by a cardholder that exceeds the authority given by the account owner.",
  '14160.action.productCode': 'CBC',
  '14160.action.type': openAccountActionType,

  '14106.name': 'Core Savings',
  '14106.url': 'https://www.wsfsbank.com/personal/banking/savings/core-savings-account/?utm_source=enlighten&utm_content=learnmore',
  '14106.description.abbreviated': 'For Customers who want to earn interest on their savings, while still being able to access their money easily.',
  '14106.features.count': 2,
  '14106.features.1': 'Make unlimited deposits into your account.*',
  '14106.features.2': 'Manage your accounts anywhere, anytime with Online and Mobile Banking.',
  '14106.additionalInfo.count': 4,
  '14106.additionalInfo.1': 'Minimum Daily Balance: $500 to avoid $5 cost.',
  '14106.additionalInfo.2': '$25 auto transfer from checking account to avoid $5 cost.',
  '14106.additionalInfo.3': 'Electronic or Paper statement option available at no cost.',
  '14106.additionalInfo.4': '<a class="additionalInfoLink" href="http://wsfsweb/Portals/5/Personal%20Solutions/Personal%20%20Solutions-%20Savings.pdf">View Rates</a>',
  '14106.disclosures.count': 1,
  '14106.disclosures.1': '*You may make no more than six preauthorized withdrawals, automatic or telephonic transfers, checks, drafts, and debit card or other similar transactions from your account per month or statement cycle. Federal regulations require compliance with these restrictions. We may be required to close your account, take away any ability to transfer and write checks or convert the account to a checking or other transaction account if these restrictions are violated.',
  '14106.callToAction.count': 0,
  '14106.action.productCode': 'CSS',
  '14106.action.type': openAccountActionType,

  /**
   * ============================
   * savings / cds / money markets
   * ============================
   */

  '14125.name': 'High-Yield Money Market',
  '14125.url': 'https://www.wsfsbank.com/personal/banking/savings/high-yield-money-market/?utm_source=enlighten&utm_content=learnmore',
  '14125.description.abbreviated': 'For Customers who maintain higher balances in their money market account and are looking for a competitive rate of interest.',
  '14125.features.count': 5,
  '14125.features.1': 'Tiered interest rates allow you to earn more interest on higher balances.',
  '14125.features.2': 'Make unlimited deposits into your account.*',
  '14125.features.3': 'Link your money market account to a Relationship checking account to earn a higher rate of interest.',
  '14125.features.4': 'Manage your accounts anywhere, anytime with Online and Mobile Banking.',
  '14125.features.5': 'Overdraft protection available when you link your money market account to your WSFS checking account.',
  '14125.additionalInfo.count': 1,
  '14125.additionalInfo.1': '<a class="additionalInfoLink" href="http://wsfsweb/Portals/5/Product%20Information/Personal%20%20Solutions%20-%20Savings%201-29-2020.pdf">View Rates</a>',
  '14125.disclosures.count': 1,
  '14125.disclosures.1': '*You may make no more than six preauthorized withdrawals, automatic or telephonic transfers, checks, drafts, and debit card or other similar transactions from your account per month or statement cycle. Federal regulations require compliance with these restrictions. We may be required to close your account, take away any ability to transfer and write checks or convert the account to a checking or other transaction account if these restrictions are violated.',
  '14125.callToAction.count': 0,
  '14125.action.productCode': 'HYMMS',
  '14125.action.type': openAccountActionType,

  '14105.name': 'Money Market',
  '14105.url': 'https://www.wsfsbank.com/personal/banking/savings/money-market/?utm_source=enlighten&utm_content=learnmore',
  '14105.description.abbreviated': 'For Customers who want to earn higher interest than traditional savings accounts offer, with the flexibility to access their money easily.',
  '14105.features.count': 6,
  '14105.features.1': 'Tiered interest rates allow you to earn more interest on higher balances.',
  '14105.features.2': 'Make unlimited deposits into your account.*',
  '14105.features.3': 'Link your money market account to a Relationship checking account to earn a higher rate of interest.',
  '14105.features.4': 'Manage your accounts anywhere, anytime with Online and Mobile Banking.',
  '14105.features.5': 'Overdraft protection available when you link your money market account to your WSFS checking account.',
  '14105.features.6': 'Convenient account access with a WSFS Visa<sup>®</sup> Debit Card with the Visa<sup>®</sup> Zero Liability Guarantee.**',
  '14105.additionalInfo.count': 3,
  '14105.additionalInfo.1': 'Minimum Daily Balance: $5000 to avoid $12 cost.',
  '14105.additionalInfo.2': 'Electronic or Paper statement option available at no cost.',
  '14105.additionalInfo.3': '<a class="additionalInfoLink" href="http://wsfsweb/Portals/5/Personal%20Solutions/Personal%20%20Solutions-%20Savings.pdf">View Rates</a>',
  '14105.disclosures.count': 2,
  '14105.disclosures.1': '*You may make no more than six preauthorized withdrawals, automatic or telephonic transfers, checks, drafts, and debit card or other similar transactions from your account per month or statement cycle. Federal regulations require compliance with these restrictions. We may be required to close your account, take away any ability to transfer and write checks or convert the account to a checking or other transaction account if these restrictions are violated.',
  '14105.disclosures.2': "**Visa<sup>®</sup>'s Zero Liability policy covers U.S.-issued cards only and does not apply to ATM transactions, PIN transactions not processed by Visa<sup>®</sup>, or certain commercial card transactions.  Cardholder must notify issuer promptly of any unauthorized use. It also excludes a transaction made by a person authorized to transact business on the account and/or a transaction made by a cardholder that exceeds the authority given by the account owner.",
  '14105.action.productCode': 'MMS',
  '14105.action.type': openAccountActionType,

  '14108.name': 'Certificate of Deposit',
  '14108.url': 'https://www.wsfsbank.com/personal/banking/savings/fixed-rate-cd/?utm_source=enlighten&utm_content=learnmore',
  '14108.description.abbreviated': 'Set aside some of your cash to let it grow, helped along by competitive interest rates.',
  '14108.description': 'Set aside some of your cash to let it grow, helped along by competitive interest rates.',
  '14108.features.count': 1,
  '14108.features.1': 'This account is the ideal choice for Customers looking to earn a higher rate of interest and do not foresee needing access to the funds during the term*.',
  '14108.whyThis.count': 1,
  '14108.whyThis.1': 'This account is the ideal choice for Customers looking to earn a higher rate of interest and do not foresee needing access to the funds during the term.',
  '14108.additionalInfo.count': 2,
  '14108.additionalInfo.1': 'Minimum opening deposit is $2500',
  '14108.additionalInfo.2': '<a class="additionalInfoLink" href="http://wsfsweb/Portals/5/Personal%20Solutions/Personal%20%20Solutions-%20Savings.pdf">View Rates</a>',
  '14108.disclosures.count': 1,
  '14108.disclosures.1': "*Withdrawal penalties are as follows. For a 6 month term, the penalty is 3 months' interest. For a term from 7-12 months, the penalty is 6 months' interest. For a term of 13 or more months, the penalty is 12 months' interest. Fees could reduce earnings on the account. Additional restrictions may apply.",
  '14108.action.productCode': 'CTD',
  '14108.action.type': openAccountActionType,

  '14170.name': 'Certificate of Deposit',
  '14170.url': 'https://www.wsfsbank.com/Personal/Banking/Savings/Fixed-Rate-CD/?utm_source=enlighten&utm_content=learnmore',
  '14170.description.abbreviated': 'Set aside some of your cash to let it grow, helped along by competitive interest rates.',
  '14170.description': 'Set aside some of your cash to let it grow, helped along by competitive interest rates.',
  '14170.features.count': 1,
  '14170.features.1': 'This account is the ideal choice for Customers looking to earn a higher rate of interest and do not foresee needing access to the funds during the term.*',
  '14170.additionalInfo.count': 2,
  '14170.additionalInfo.1': 'Minimum opening deposit is $2500',
  '14170.additionalInfo.2': '<a class="additionalInfoLink" href="http://wsfsweb/Portals/5/Personal%20Solutions/Personal%20%20Solutions-%20Savings.pdf">View Rates</a>',
  '14170.disclosures.count': 2,
  '14170.disclosures.1': "*Withdrawal penalties are as follows. For a 6 month term, the penalty is 3 months' interest. For a term from 7-12 months, the penalty is 6 months' interest. For a term of 13 or more months, the penalty is 12 months' interest. Fees could reduce earnings on the account. Additional restrictions may apply.",
  '14170.callToAction.count': 0,
  '14170.action.productCode': 'CTD',
  '14170.action.type': openAccountActionType,

  '14171.name': 'WSFS Contactless Debit Card',
  '14171.url': 'https://www.wsfsbank.com/banking/checking-savings/personal-checking/wsfs-debit-card/?utm_source=enlighten&utm_content=learnmore',
  '14171.description.abbreviated': "The WSFS Visa<sup>®</sup> Debit Card allows you to shop, pay bills online or withdraw cash from ATMs whenever you need it and now it's contactless! When you use your new card at any merchant terminal with the contactless symbol, there will be no need to insert, swipe, or sign - simply 'Tap to Pay' and the only thing you touch is your debit card!",
  '14171.description': "The WSFS Visa<sup>®</sup> Debit Card allows you to shop, pay bills online or withdraw cash from ATMs whenever you need it and now it's contactless! When you use your new card at any merchant terminal with the contactless symbol, there will be no need to insert, swipe, or sign - simply 'Tap to Pay' and the only thing you touch is your debit card!",
  '14171.features.count': 6,
  '14171.features.1': 'The WSFS Debit Card is backed by the Visa<sup>®</sup> Zero Liability Guarantee and welcomed at millions of locations worldwide.*',
  '14171.features.2': 'Chip Technology - WSFS Visa<sup>®</sup> Debit Cards have an embedded chip that allows payment information to be securely transmitted at a chip-enabled terminal.',
  '14171.features.3': 'Price Protection – Customers can be reimbursed up to $500 ($2,500 per year) for the difference between the purchase price and printed advertised price for the same identical item within 60 days of purchase.',
  '14171.features.4': 'Purchase Security – This benefit will replace or repair, or reimburse Customers for, eligible items up to $500 ($50,000 per year) in the event of theft, damage due to fire, vandalism or accidentally discharged water or certain weather conditions within 90 days of purchase.',
  '14171.features.5': 'Return Protection – Customers can be reimbursed up to $250 ($1,000 per year) for an eligible item if the retailer won’t allow them to return the item within the first 90 days of purchase.**',
  '14171.features.6': '2Way Fraud Alerts – 2Way Fraud Alerts help to protect you by immediately alerting you of potential fraud on your debit cards through two-way texts, phone call and email alerts. If you receive a fraud alert message, simply respond whether the transaction was yours or not. No need to enroll, all debit cards are automatically covered by 2Way Fraud Alerts. Click here for <href>https://www.wsfsbank.com/banking/checking-savings/personal-checking/wsfs-debit-card/2way-fraud-alerts-faqs||FAQs</href>.',
  '14171.disclosures.count': 2,
  '14171.disclosures.1': "*Visa<sup>®</sup>'s Zero Liability policy covers U.S.-issued cards only and does not apply to ATM transactions, PIN transactions not processed by Visa<sup>®</sup>, or certain commercial card transactions. Cardholder must notify issuer promptly of any unauthorized use. It also excludes a transaction made by a person authorized to transact business on the account and/or a transaction made by a cardholder that exceeds the authority given by the account owner.",
  '14171.disclosures.2': "**Certain terms, conditions and exclusions apply. Please refer to the Guide to WSFS Visa<sup>®</sup> Debit Card Benefits for more details.",
  '14171.action.type': contactUsActionType,

  /**
   * ============================
   * digital solutions
   * ============================
   */

   '14123.name': 'WSFS Online Banking',
   '14123.url': 'https://www.wsfsbank.com/personal/banking/online-mobile/?utm_source=enlighten&utm_content=learnmore',
   '14123.description.abbreviated': "WSFS Online Banking lets you manage your accounts when it's convenient for you.",
   '14123.description': "WSFS Online Banking lets you manage your accounts when it's convenient for you.",
   '14123.features.count': 2,
   '14123.features.1': 'Offers convenient banking when you need it - 24 hours a day.*',
   '14123.features.2': 'Faster access to pay bills, make payments or check balances.',
   '14123.additionalInfo.count': 1,
   '14123.additionalInfo.1': '<a class="additionalInfoLink" href="http://wsfsweb/Portals/5/Mobile%20and%20Online%20Solutions.pdf">View Digital Solution Grid</a>',
   '14123.disclosures.count': 1,
   '14123.disclosures.1': '*WSFS does not charge a fee for Online Banking Alerts, but wireless carrier service charges for data usage may apply. Wireless carrier text message and web access charges may apply. Your wireless carrier may charge for using the SMS text message feature on your mobile phone. Some carriers may charge additional fees to use their short code texting services.',
   '14123.callToAction.count': 1,
   '14123.callToAction.1': '<a class="callToActionLink" href="https://cibng.ibanking-services.com/cib/themes/cib_enroll/enroll/enroll.jsp?FIORG=108&FIFID=031100102">Enroll</a> at WSFSbank.com.',
   '14123.action.type': enrollOnlineActionType,

   '14124.name': 'WSFS Mobile Banking',
   '14124.url': 'https://www.wsfsbank.com/personal/banking/online-mobile/?utm_source=enlighten&utm_content=learnmore',
   '14124.description.abbreviated': "WSFS Mobile Banking lets you manage your accounts whenever and wherever it's convenient for you.",
   '14124.description': "WSFS Mobile Banking lets you manage your accounts whenever and wherever it's convenient for you.",
   '14124.features.count': 1,
   '14124.features.1': 'The go-anywhere, do anything WSFS Mobile App will change the way you manage your money for the better.',
   '14124.additionalInfo.count': 1,
   '14124.additionalInfo.1': '<a class="additionalInfoLink" href="http://wsfsweb/Portals/5/Mobile%20and%20Online%20Solutions.pdf">View Digital Solution Grid</a>',
   '14124.disclosures.count': 0,
   '14124.callToAction.count': 1,
   '14124.callToAction.1': 'Get the WSFS Mobile Banking App Now on the Apple App Store or Google Play!',
   '14124.action.type': getTheAppActionType,

  /**
   * ============================
   * credit cards
   * ============================
   */

  '14121.name': 'Platinum VISA',
  '14121.url': 'https://www.wsfsbank.com/personal/banking/credit-cards/platinum-credit-card/?utm_source=enlighten&utm_content=learnmore',
  '14121.description.abbreviated': "For those looking for a low APR and a simple, convenient credit card.",
  '14121.description': "For those looking for a low APR and a simple, convenient credit card.",
  '14121.features.count': 5,
  '14121.features.1': 'Our Service- WSFS Customers will experience the same great service they are accustomed to since our cards are now serviced and maintained in house',
  '14121.features.2': 'Online Access- Customers will have the ability to view their credit card information via WSFS online banking',
  '14121.features.3': '24/7 Telephone Customer Service',
  '14121.features.4': 'Local decisions- underwriting occurs within WSFS Bank',
  '14121.features.5': 'Trained Associates are ready to handle any credit card questions and have the ability to process routine maintenance requests',
  '14121.additionalInfo.count': 0,
  '14121.disclosures.count': 2,
  '14121.disclosures.1': 'Based on your creditworthiness.',
  '14121.disclosures.2': '0% APR for 9 full billing cycles if completed in first 3 billing cycles of account opening. Fees may apply',
  '14121.action.productCode': 'CreditCard_CashBackVisa',
  '14121.action.type': lowInterestCreditCard,

  '14122.name': 'Cash Back VISA',
  '14122.url': 'https://www.wsfsbank.com/personal/banking/credit-cards/cash-back-credit-card/?utm_source=enlighten&utm_content=learnmore',
  '14122.description.abbreviated': "For those wanting unlimited cash back on all their purchases.",
  '14122.description': "For those wanting unlimited cash back on all their purchases.",
  '14122.features.count': 5,
  '14122.features.1': 'Our Service- WSFS Customers will experience the same great service they are accustomed to since our cards are now serviced and maintained in house',
  '14122.features.2': 'Online Access- Customers will have the ability to view their credit card information via WSFS online banking',
  '14122.features.3': '24/7 Telephone Customer Service',
  '14122.features.4': 'Local decisions- underwriting occurs within WSFS Bank',
  '14122.features.5': 'Trained Associates are ready to handle any credit card questions and have the ability to process routine maintenance requests',
  '14122.additionalInfo.count': 0,
  '14122.disclosures.count': 3,
  '14122.disclosures.1': 'Cash back applies on all retail purchases and excludes returns, balance transfers, cash advances, fees, and finance charges. Other exclusions may apply.',
  '14122.disclosures.2': 'Based on your creditworthiness.',
  '14122.disclosures.3': '0% APR for 9 full billing cycles if completed in first 3 billing cycles of account opening. Fees may apply.',
  '14122.action.productCode': 'CreditCard_PlatinumVisa',
  '14122.action.type': cashBackCreditCard,

  /**
   * ============================
   * loans
   * ============================
   */

   '14110.name': 'Home Equity Line of Credit',
   '14110.url': 'https://www.wsfsbank.com/personal/borrowing/home-equity-loans-and-lines/home-equity-lines-of-credit/?utm_source=enlighten&utm_content=learnmore',
   '14110.description.abbreviated': "Borrow what you need, when you need it. Get started on some of the projects on your list, consolidate debt, or finance a big purchase. With a convenient option to convert your HELOC to a fixed rate loan for the total loan amount or a portion of the loan.",
   '14110.description': "Borrow what you need, when you need it. Get started on some of the projects on your list, consolidate debt, or finance a big purchase. With a convenient option to convert your HELOC to a fixed rate loan for the total loan amount or a portion of the loan.",
   '14110.features.count': 3,
   '14110.features.1': 'Flexible payout – receive funds all at once or in various amounts over time',
   '14110.features.2': 'Easy access by check, VISA<sup>®</sup> Access Card, online and mobile banking transfers, or by request',
   '14110.features.3': 'Offers ability to lock in all or a portion of your outstanding balance to a fixed rate, fixed term loan',
   '14110.additionalInfo.count': 0,
   '14110.disclosures.count': 3,
   '14110.disclosures.1': 'Subject to credit review and approval.',
   '14110.disclosures.2': 'The "interest only" portion of this Convertible HELOC allows you to pay only the interest on the money you borrow for 10 years (draw period) from the date the line is established. A 20-year repayment period, during which you must pay principal and interest, follows the 10 year draw period. Interest-only payments do not build home equity. If you pay only the amount of interest that is due, once the interest-only period ends, you will still owe the original amount that you borrowed and your monthly payment will increase significantly because you must pay back the principal as well as the interest, even if interest rates remain the same.',
   '14110.disclosures.3': 'Primary residences, secondary residences and investment properties are eligible. The following property types are not eligible: mixed-use properties, life estates, co-ops, timeshares, working farms, commercial properties and land/lots.',
   '14110.action.productCode': 'HELOC',
   '14110.action.type': openLineOfCredit,

   '14111.name': 'Home Equity Loan',
   '14111.url': 'https://www.wsfsbank.com/personal/borrowing/home-equity-loans-and-lines/home-equity-loans/?utm_source=enlighten&utm_content=learnmore',
   '14111.description.abbreviated': "Borrow a fixed amount of money at a low rate and repay it over time in easy monthly payments. Get started on some of the projects on your list, consolidate debt, or finance a big purchase.",
   '14111.description': "Borrow a fixed amount of money at a low rate and repay it over time in easy monthly payments. Get started on some of the projects on your list, consolidate debt, or finance a big purchase.",
   '14111.features.count': 2,
   '14111.features.1': 'Earn a rate discount for making automatic payments from your WSFS checking account',
   '14111.features.2': 'Repay over time in easy monthly installments - payment is the same throughout the term so you can budget accordingly',
   '14111.additionalInfo.count': 0,
   '14111.disclosures.count': 2,
   '14111.disclosures.1': 'Subject to credit review and approval.',
   '14111.disclosures.2': 'Primary residences, secondary residences and investment properties are eligible. The following property types are not eligible: mixed-use properties, life estates, co-ops, timeshares, working farms, commercial properties and land/lots.',
   '14111.action.type': homeEquityLoan,

   '14112.name': 'Auto Loan',
   '14112.url': 'https://www.wsfsbank.com/Personal/Borrowing/Auto-Loans/?utm_source=enlighten&utm_content=learnmore',
   '14112.description.abbreviated': "Simplify your vehicle-buying experience with a vehicle loan from WSFS.",
   '14112.description': "Simplify your vehicle-buying experience with a vehicle loan from WSFS.",
   '14112.features.count': 2,
   '14112.features.1': 'Earn a rate discount for making automatic payments from your WSFS checking account',
   '14112.features.2': 'Repay over time in easy monthly installments - payment is the same throughout the term so you can budget accordingly',
   '14112.additionalInfo.count': 0,
   '14112.disclosures.count': 1,
   '14112.disclosures.1': 'Subject to credit review and approval.',
   '14112.action.productCode': 'auto_loan',
   '14112.action.type': openAutoLoan,

   '14117.name': 'Personal Unsecured Loan',
   '14117.url': 'https://www.wsfsbank.com/personal/borrowing/personal-loans-and-lines/personal-loans/?utm_source=enlighten&utm_content=learnmore',
   '14117.description.abbreviated': `Use a personal loan for quick access to cash, to consolidate debts, or to finance large expenses – from wedding to home improvements.
                                      <ul>
                                        <li>Get approved in minutes and funds as soon as the next day<sup>2</sup></li>
                                        <li>Save money by consolidating debts into one, simple monthly payment</li>
                                        <li>No origination, prepayment, or annual fees</li>
                                        <li>Borrow as little or as much as you need – from $5,000 - $50,000</li>
                                      </ul>
                                    `,
   '14117.description': "Use a personal loan for quick access to cash, to consolidate debts, or to finance large expenses – from wedding to home improvements.",
   '14117.features.count': 4,
   '14117.features.1': 'No collateral needed',
   '14117.features.2': 'Check your rate with no impact to your credit score',
   '14117.features.3': 'Pay for expected and unexpected expenses',
   '14117.features.4': 'Pay back the loan over 3 or 5 years',
   '14117.additionalInfo.count': 0,
   '14117.disclosures.count': 2,
   '14117.disclosures.1': 'Subject to credit review and approval.',
   '14117.disclosures.2': 'If you accept your loan by 5:00 pm ET (not including weekends or holidays), you will generally receive your funds the next business day. If accepted after 5:00 pm ET Monday-Friday or during the weekend or holidays, you will generally receive your funds two business days later.',
   '14117.action.type': upstartActionType,

   '14156.name': 'Connect with a Lending Specialist',
   '14156.url': '',
   '14156.description.abbreviated': "Thank you for sharing your financial information with us. Connecting with a WSFS Bank Lending Specialist is the best pathway to provide you with the most personalized borrowing recommendations.  Simply enter your contact information on the right, and a Lending Specialist will reach out to you within 48 business hours.  You can also reach us at 1-888-973-7226.",
   '14156.description': "Thank you for sharing your financial information with us. Connecting with a WSFS Bank Lending Specialist is the best pathway to provide you with the most personalized borrowing recommendations.  Simply enter your contact information on the right, and a Lending Specialist will reach out to you within 48 business hours.  You can also reach us at 1-888-973-7226.",
   '14156.features.count': 0,
   '14156.additionalInfo.count': 0,
   '14156.disclosures.count': 0,
   '14156.action.type': lendingSpecialist,

}
